/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect } from 'react';
import { withPrefix } from 'gatsby';
import SWBreadcrumb from '../SWBreadcrumb';
import {
  BreadcrumbProps,
  ItemListElement,
} from './types/SectionBreadcrumb.types';
import { StructuredData } from '../../../SEO/StructuredData';
import useSiteMetadata from '../../../../hooks/useSiteMetadata';
import setupBreadcrumbAnalitycsTags from '../../../../helpers/setupBreadcrumbs';
import { breadcrumbWrapper } from './styles/SectionBreadcrumb.styles';

const SectionBreadcrumb = ({ items, location }: BreadcrumbProps) => {
  const { siteUrl } = useSiteMetadata();
  const itemListElement: ItemListElement[] = [];

  useEffect(() => {
    setupBreadcrumbAnalitycsTags();
  }, []);

  if (Array.isArray(items)) {
    items.forEach((item, index) => {
      const { id, label, href } = item;
      const itemHref = item.external ? href : `${siteUrl}${withPrefix(href)}`;
      itemListElement.push({
        '@type': 'ListItem',
        position: index + 1,
        name: label,
        item: itemHref,
      });
    });
  }

  return (
    <div css={breadcrumbWrapper}>
      <SWBreadcrumb
        location={'sectionBreadcrumb'}
        items={items.map(item => {
          const { id, label, href, external } = item;
          return {
            id: item.id,
            text: `${item.label}`,
            href: item.external
              ? item.href
              : location?.origin
              ? location.origin + withPrefix(item.href)
              : withPrefix(item.href),
          };
        })}
      />
      <StructuredData>
        {{
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement,
        }}
      </StructuredData>
    </div>
  );
};

export default SectionBreadcrumb;
